import { render, staticRenderFns } from "./r-map-addon-config-page.vue?vue&type=template&id=779074d6"
import script from "./r-map-addon-config-page.vue?vue&type=script&lang=js"
export * from "./r-map-addon-config-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('779074d6')) {
      api.createRecord('779074d6', component.options)
    } else {
      api.reload('779074d6', component.options)
    }
    module.hot.accept("./r-map-addon-config-page.vue?vue&type=template&id=779074d6", function () {
      api.rerender('779074d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/map-addon/r-map-addon-config-page.vue"
export default component.exports